// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import smoothscroll from 'smoothscroll-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VModal from 'vue-js-modal'
import store from './store/index'
import endpoints from './endpoints'
import axios from 'axios'
import vSelect from '../node_modules/vue-select/dist/vue-select.js'
import './assets/scss/styles.scss'
import SitesMixin from './mixins/sites'
import './plugins/cookieconsent'
import { ObserveVisibility } from 'vue-observe-visibility'
import vueHeadful from 'vue-headful'

import 'vue-select/dist/vue-select.css'


Vue.component('vue-headful', vueHeadful)

Vue.directive('observe-visibility', ObserveVisibility)

axios.defaults.withCredentials = true

// force HTTPS
if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
  location.protocol = 'https:'
}

// remove www. if not pizzaheinz
if (window.type !== 'pizzaheinz' && location.hostname.search('www.') !== -1) {
  location.href = location.href.replace('www.', '')
}

// manage token before starting any other XHR requests
if (!store.getters.token) {
  console.log('renew token')

  let request = new XMLHttpRequest();
  request.open('GET', endpoints.gettoken, false)
  request.send(null)

  if (request.status === 200) {
    store.commit('setToken', JSON.parse(request.responseText).token)
    console.log('got new token ' + store.getters.token)
  }
} else {
  console.log('use existing token ' + store.getters.token)
}

// request interceptor to add token
axios.interceptors.request.use(function (config) {
  config.headers['X-Pizzaheinz-Token'] = store.getters.token
  config.headers['X-Pizzaheinz-System'] = window.type
  return config
}, function (error) {
  return Promise.reject(error)
})

// response interceptor to fetch token renew command
axios.interceptors.response.use(function (response) {
  if (response.headers['content-type'] === 'application/renewtoken') {
    store.commit('setToken', null)
    window.location.reload()
  }

  return response
}, function (error) {
  return Promise.reject(error)
})

if (typeof window.Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

smoothscroll.polyfill()

Vue.config.productionTip = false
Vue.use(VModal, { dialog: true })

Vue.mixin(SitesMixin)

/* eslint-disable no-new */

Vue.component('v-select', vSelect)

Vue.filter('pricetag', function (value) {
  if (Number(value) === 0) {
    return null
  }

  return Number(value).toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' €'
})

Vue.filter('addPlusIfNotNull', function (value) {
  return (value === null ? value : ' + ' + value)
})

window.eventBus = new Vue({})

const createapp = () => {
  const app = new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
  })
}

if (process.env.NODE_ENV === 'production') {
  createapp()
} else {
  // set default host for DEV environment without processing production.php
  console.log(['DEV MODE - call API for hostdescription', window.hostId])

  window.hostId = 0

  axios.post(endpoints.hostdescription, { 'hostId': window.hostId })
    .then(response => {
      window.hostUrl = response.data.url
      window.startContent = response.data.content
      window.logo = response.data.logo
      window.homedelivery = true
      window.logoTitle = response.data.logotitle
      window.baseTitle = response.data.title
      window.facebook = response.data.facebook
      window.instagram = response.data.instagram
      window.healthy = 'true'
      document.title = response.data.title

      if (window.type === 'foodi') {
        document.body.classList.add('foodi')
      } else {
        document.body.classList.add('host-' + response.data.id)
      }

      createapp()
    })
    .catch(e => {
      console.log(['failed loading menu', e])
    })
}

// get customer site styles
if (window.type === 'customer') {
  document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', '<link id="customerStyles" rel="stylesheet" href="' + endpoints.baseUrl + '/website/styles/' + window.hostId + '.css" />')
}

// set focus on first element after route change
router.afterEach(() => {
  console.log('route changed')
  Vue.nextTick(() => {
    const firstFocusable = document.body.querySelector('#app').querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    console.log('first focusable', firstFocusable)
    if (firstFocusable) firstFocusable.focus()
  })
})



// WEBPACK FOOTER //
// ./src/main.js